var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"monitor",style:(_vm.nameData.length > 1 ? '' : 'margin-top:20px')},[_c('div',{ref:"chartRef",staticClass:"chart-container",style:({ height: _vm.height })})])
}
var staticRenderFns = []

export { render, staticRenderFns }